var exports = (module.exports = {});
exports.mapStyleSpec = [
    {
        id: "gl-draw-polygon-fill-inactive",
        type: "fill",
        filter: ["all", ["==", "active", "false"], ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
        paint: {
            "fill-color": {
                type: "identity",
                property: "user_polygon_fill_color_active_inactive"
            },
            "fill-outline-color": "#ff0200",
            "fill-opacity": 0.2
        }
    },
    {
        id: "gl-draw-polygon-fill-active",
        type: "fill",
        filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
        paint: {
            //when we are drawing what color should the middle of the plogon be drawn as
            //fill-color": "#d9ca78",
            "fill-color": {
                type: "identity",
                property: "user_polygon_fill_color_active_inactive"
            },
            "fill-outline-color": "#afa45a",
            "fill-opacity": 0.2
        }
    },
    {
        id: "gl-draw-polygon-stroke-active",
        type: "line",
        filter: ["all", ["==", "active", "true"], ["==", "$type", "Polygon"]],
        layout: {
            "line-cap": "round",
            "line-join": "round"
        },
        paint: {
            //Basically this covers what an active polygon we draw is supposed to have its border as
            //this is what is drawn when we have drawn the first and second spots and now keep drawing
            "line-color": "#ffd105",
            //the first number specifies how far away each dash is, the 2nd shows how long each dash is
            "line-dasharray": [0.2, 2],
            "line-width": 2
        }
    },
    {
        id: "gl-draw-polygon-midpoint",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
        paint: {
            // says how big the little circle marking everything for us is
            "circle-radius": 3,
            //This colors the little dots that appear on the polygon when we draw it and click on a line segment
            "circle-color": "#fbb03b"
        }
    },
    {
        id: "gl-draw-polygon-stroke-inactive",
        type: "line",
        filter: ["all", ["==", "active", "false"], ["==", "$type", "Polygon"], ["!=", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round"
        },
        paint: {
            //The color of the lines once we have finished drawing this one.
            "line-color": {
                type: "identity",
                property: "user_polygon_stroke_inactive"
            },
            // width of the line drawn around our thing
            "line-width": 2
        }
    },
    {
        id: "gl-draw-polygon-stroke-static",
        type: "line",
        filter: ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
        layout: {
            "line-cap": "round",
            "line-join": "round"
        },
        paint: {
            "line-color": "#404040",
            "line-width": 2
        }
    },
    {
        //how to color the points in a polygon, the MAIN points in a poly
        ////OUTER circle
        id: "gl-draw-polygon-and-line-vertex-stroke-inactive",
        type: "circle",
        filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
        paint: {
            "circle-radius": 5,
            "circle-color": "#fff"
        }
    },
    {
        //how to color the points in a polygon, the MAIN points in a poly
        ////INNER circle
        id: "gl-draw-polygon-and-line-vertex-inactive",
        type: "circle",
        filter: ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
        paint: {
            "circle-radius": 3,
            "circle-color": "#fbb03b"
        }
    },
    {
        id: "gl-draw-polygon-fill-static",
        type: "fill",
        filter: ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
        paint: {
            "fill-color": "#404040",
            "fill-outline-color": "#404040",
            "fill-opacity": 0.1
        }
    },
    //End of polygon
    {
        id: "gl-draw-line-inactive",
        type: "line",
        filter: ["all", ["==", "active", "false"], ["==", "$type", "LineString"], ["!=", "mode", "static"]],
        layout: {
            "line-cap": "round",
            "line-join": "round"
        },
        paint: {
            "line-color": "#3bb2d0",
            "line-width": 2
        }
    },
    {
        id: "gl-draw-line-active",
        type: "line",
        filter: ["all", ["==", "$type", "LineString"], ["==", "active", "true"]],
        layout: {
            "line-cap": "round",
            "line-join": "round"
        },
        paint: {
            "line-color": "#fbb03b",
            "line-dasharray": [0.2, 2],
            "line-width": 2
        }
    },
    {
        id: "gl-draw-point-point-stroke-inactive",
        type: "circle",
        filter: [
            "all",
            ["==", "active", "false"],
            ["==", "$type", "Point"],
            ["==", "meta", "feature"],
            ["!=", "mode", "static"]
        ],
        paint: {
            "circle-radius": 5,
            "circle-opacity": 1,
            "circle-color": "#fff"
        }
    },
    {
        id: "gl-draw-point-inactive",
        type: "circle",
        filter: [
            "all",
            ["==", "active", "false"],
            ["==", "$type", "Point"],
            ["==", "meta", "feature"],
            ["!=", "mode", "static"]
        ],
        paint: {
            "circle-radius": 3,
            "circle-color": "#3bb2d0"
        }
    },
    {
        id: "gl-draw-point-stroke-active",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["==", "active", "true"], ["!=", "meta", "midpoint"]],
        paint: {
            "circle-radius": 7,
            "circle-color": "#fff"
        }
    },
    {
        id: "gl-draw-point-active",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["!=", "meta", "midpoint"], ["==", "active", "true"]],
        paint: {
            "circle-radius": 5,
            "circle-color": "#fbb03b"
        }
    },
    {
        id: "gl-draw-line-static",
        type: "line",
        filter: ["all", ["==", "mode", "static"], ["==", "$type", "LineString"]],
        layout: {
            "line-cap": "round",
            "line-join": "round"
        },
        paint: {
            "line-color": "#404040",
            "line-width": 2
        }
    },
    {
        id: "gl-draw-point-static",
        type: "circle",
        filter: ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
        paint: {
            "circle-radius": 5,
            "circle-color": "#404040"
        }
    }
];

exports.extraStyleSettings = {
    cutTool_Active_FillColor_when_hasNoIntersect: "#000",
    cutTool_Active_FillColor_when_hasIntersect: "#f00",
    cutTool_Active_StrokeColor_when_hasIntersect: "#f00",

    cutTool_FillColor_when_finished: "#ffd105",
    cutTool_StrokeColor_when_finished: "#ffd105",

    basePolygon_FillColor_when_finished: "#a00",
    basePolygon_StrokeColor_when_finished: "#a00"
};
